import { gql } from '@apollo/client';

export const GET_CUSTOM_FONTS = gql`
  query getCustomFonts($teamId: String!) {
    getCustomFonts(teamId: $teamId) {
      fontFamily
      fontSubfamily
      AWSS3ID
      url
      bucket
    }
  }
`;

export const DELETE_FONT_FILES = gql`
  mutation deleteFontFiles($payload: DeleteFontFilesInput!, $teamId: String!) {
    deleteFontFiles(payload: $payload, teamId: $teamId) {
      fontFamily
      fontSubfamily
      AWSS3ID
    }
  }
`;

/** Fetch Transloadit assembly options for font uploads (no args — uses auth context). */
export const GET_FONT_UPLOAD_OPTIONS = gql`
  query getFontUploadOptions {
    getFontUploadOptions
  }
`;

/** Save uploaded fonts to DB after Transloadit assembly completes. */
export const INSERT_FONTS = gql`
  mutation insertFonts($fonts: [CreateFontInput!]!, $teamId: String!) {
    insertFonts(fonts: $fonts, teamId: $teamId)
  }
`;
